import * as yup from "yup";

const depositValidationSchema = yup.object().shape({
    deposit: yup
        .number()
        .nullable()
        .positive('Deve essere un numero positivo')
        .typeError('Deve essere un numero'),
});

export default depositValidationSchema;